import { customToastr } from '../../../../../library/toastr/toastr';
import { TOASTR_TYPE_ERROR } from '../../../../../utils/toastr';
import { TRANSLATIONS_PRODUCT_TITLE_REPLACEMENT } from '../constants';
import { getMealCount } from './meals';

export const PHASE_STEP_COMPLETED = 'completed';
export const PHASE_STEP_EXCEEDED_AVAILABILITY = 'exceeded-availability';
export const PHASE_STEP_PARTIALLY_COMPLETED = 'partly-completed';
export const PHASE_STEP_INCOMPLETED = 'incompleted';

const productIconClassNames = {
    microwave: '25-priprava-mikrovlnka.svg',
    shaker: '25-priprava-shaker.svg',
    spoon: '25-priprava-maslovacka.svg',
    pot: '25-priprava-hrnec.svg',
};

export const getPhaseStepLabelByOrder = (order) => (phaseStepLabels[order] ? phaseStepLabels[order] : 'snídaní');

const phaseStepLabels = {
    1: 'snídaní',
    2: 'svačin',
    3: 'obědů',
    4: 'večeří',
};

export const getPhaseStepLimitKeyByOrder = (order) =>
    phaseStepLimit[order] ? phaseStepLimit[order] : 'breakfastMealCount';

const phaseStepLimit = {
    1: 'breakfastMealCount',
    2: 'snackMealCount',
    3: 'lunchMealCount',
    4: 'supperMealCount',
};

export const getPhaseStepNameByOrder = (order) => (phaseStepNames[order] ? phaseStepNames[order] : 'breakfast');

const phaseStepNames = {
    1: 'breakfast',
    2: 'snack',
    3: 'lunch',
    4: 'supper',
};

export const getContinueToPhaseStepTranslationKey = (step) =>
    continueToPhaseStepTranslationKeys[step]
        ? continueToPhaseStepTranslationKeys[step]
        : 'eshop.configurator.action.select_step_snack';

const continueToPhaseStepTranslationKeys = {
    1: 'eshop.configurator.action.select_step_breakfast',
    2: 'eshop.configurator.action.select_step_snack',
    3: 'eshop.configurator.action.select_step_lunch',
    4: 'eshop.configurator.action.select_step_supper',
};

export const getPhaseStepTranslationKey = (step) =>
    phaseStepTranslationKeys[step] ? phaseStepTranslationKeys[step] : 'eshop.configurator.action.phase_step_snack';

const phaseStepTranslationKeys = {
    1: 'eshop.configurator.action.phase_step_breakfast',
    2: 'eshop.configurator.action.phase_step_snack',
    3: 'eshop.configurator.action.phase_step_lunch',
    4: 'eshop.configurator.action.phase_step_supper',
};

export const getIconClassNameByFlag = (flag) => (productIconClassNames[flag] ? productIconClassNames[flag] : null);

export const getPhasePortionCount = (phase) =>
    phase.breakfastMealCount + phase.snackMealCount + phase.lunchMealCount + phase.supperMealCount;

const dishTypes = {
    1: 'breakfast',
    2: 'snack',
    3: 'lunch',
    4: 'supper',
};

export const getDishByPhaseStep = (phaseStep) => (dishTypes[phaseStep] ? dishTypes[phaseStep] : 'breakfast');

const phaseSteps = {
    breakfast: 1,
    snack: 2,
    lunch: 3,
    supper: 4,
};

export const getPhaseStepByDish = (dishType) => (phaseSteps[dishType] ? phaseSteps[dishType] : 1);

export const getFirstPhaseStep = (phase) => phase.steps[0];

export const getLastPhaseStep = (phase) => phase.steps[phase.steps.length - 1];

export const getNextPhaseStep = (phase, currentStep) => {
    const currentPhaseStepIndex = phase.steps.indexOf(currentStep);
    return phase.steps[currentPhaseStepIndex + 1];
};

export const getPrevPhaseStep = (phase, currentStep) => {
    const currentPhaseStepIndex = phase.steps.indexOf(currentStep);

    return phase.steps[currentPhaseStepIndex - 1];
};

const isPhaseStepBreakfast = (phaseStep) => phaseStep === 1;

const isPhaseStepSnack = (phaseStep) => phaseStep === 2;

const isPhaseStepLunch = (phaseStep) => phaseStep === 3;

const isPhaseStepDinner = (phaseStep) => phaseStep === 4;

export const getProductsByPhaseStep = (products, phaseStep) => {
    const hasProducts = products && products.length > 0;

    if (!hasProducts) {
        return products;
    }

    const phaseStepArray = [getDishByPhaseStep(phaseStep)];

    // Pro snídaně zobrazíme i jídla ze svačin
    if (isPhaseStepBreakfast(phaseStep)) {
        phaseStepArray.push(getDishByPhaseStep(2));
    }

    // Pro svačiny zobrazíme i jídla ze snídaní
    if (isPhaseStepSnack(phaseStep)) {
        phaseStepArray.push(getDishByPhaseStep(1));
    }

    // Pro obědy zobrazíme i jídla z večeří
    if (isPhaseStepLunch(phaseStep)) {
        phaseStepArray.push(getDishByPhaseStep(4));
    }

    if (isPhaseStepDinner(phaseStep)) {
        phaseStepArray.push(getDishByPhaseStep(3));
    }

    return products.filter((product) => product.dishTypes.some((dishType) => phaseStepArray.includes(dishType)));
};

export const getPhaseStepStatus = (pickedProducts, mealsLimit, productAvailabilityMap) => {
    const hasPickedProductExceedAvailability =
        pickedProducts && productAvailabilityMap
            ? pickedProducts.some((pickedProduct) =>
                  productAvailabilityMap[pickedProduct.id]
                      ? productAvailabilityMap[pickedProduct.id].available < 0
                      : false
              )
            : false;

    const pickedProductsCount = getMealCount(pickedProducts);

    if (mealsLimit === pickedProductsCount) {
        if (hasPickedProductExceedAvailability) {
            return PHASE_STEP_EXCEEDED_AVAILABILITY;
        }
        return PHASE_STEP_COMPLETED;
    }

    return pickedProductsCount > 0 ? PHASE_STEP_PARTIALLY_COMPLETED : PHASE_STEP_INCOMPLETED;
};

// Funkce vrací index první nevyplěné fáze, -1 pokud neexistují fáze
export const getFirstIncompletedPhaseIndex = (phases, loadPhaseProductsFromStorage, productAvailabilityMap) => {
    if (!phases || !productAvailabilityMap) {
        return -1;
    }

    for (let index = 0; index < phases.length; index++) {
        const phase = phases[index];

        const phaseProducts = loadPhaseProductsFromStorage(phase.id);
        const isCurrentPhaseCompleted = isPhaseCompleted(phase, phaseProducts, productAvailabilityMap);

        if (!isCurrentPhaseCompleted) {
            return index;
        }
    }

    return phases.length - 1;
};

export const getFirstIncompletedPhaseStepIndex = (phase, pickedPhaseProducts, productAvailabilityMap) => {
    if (!phase || !phase.steps || !productAvailabilityMap) {
        return -1;
    }

    for (let index = 0; index < phase.steps.length; index++) {
        const phaseStep = phase.steps[index];

        const isCurrentPhaseStepCompleted = isPhaseStepCompleted(
            phaseStep,
            phase,
            pickedPhaseProducts,
            productAvailabilityMap
        );

        if (!isCurrentPhaseStepCompleted) {
            return index;
        }
    }
    return phase.steps.length - 1;
};

const isPhaseCompleted = (phase, phaseProducts, productAvailabilityMap) =>
    phase.steps.every((phaseStep) => isPhaseStepCompleted(phaseStep, phase, phaseProducts, productAvailabilityMap));

const isPhaseStepCompleted = (phaseStep, phase, phaseProducts, productAvailabilityMap) => {
    const pickedPhaseStepProducts = phaseProducts ? phaseProducts[phaseStep] : undefined;
    const mealsLimit = phase ? phase[getPhaseStepLimitKeyByOrder(phaseStep)] : 0;

    const phaseStepStatus =
        pickedPhaseStepProducts && productAvailabilityMap
            ? getPhaseStepStatus(pickedPhaseStepProducts, mealsLimit, productAvailabilityMap)
            : PHASE_STEP_INCOMPLETED;

    return phaseStepStatus === PHASE_STEP_COMPLETED;
};

export const getPickedPhaseProductCount = (phase, loadPhaseProductsFromStorage) => {
    const pickedPhaseProducts = loadPhaseProductsFromStorage(phase.id);

    if (!phase.steps || !pickedPhaseProducts) {
        return 0;
    }

    return phase.steps.reduce(
        (prevPickedPhaseProductsCount, phaseStep) =>
            prevPickedPhaseProductsCount + getMealCount(pickedPhaseProducts[phaseStep]),
        0
    );
};

export const showDeleteItemFlashMessage = (itemName, translations) => {
    customToastr(
        TOASTR_TYPE_ERROR,
        translations['eshop.configurator.info.unavailable_product_removed'].replace(
            TRANSLATIONS_PRODUCT_TITLE_REPLACEMENT,
            itemName || '---'
        )
    );
};

export const filterSoldOutProducts = (products, removeProductIds, productAvailabilityMap, translations) => {
    if (!products || products.length <= 0) {
        return [];
    }

    return products.filter((product) => {
        const isProductSoldOut = productAvailabilityMap[product.id] === undefined;

        // Byl produkt vyprodán od té doby co je uložen v localStorage?
        if (isProductSoldOut) {
            const isProductMessageAlreadyShown = removeProductIds.includes(product.id);

            // Chceme zobrazit flashMessage pro daný produkt jen jednou
            if (!isProductMessageAlreadyShown) {
                removeProductIds.push(product.id);
                showDeleteItemFlashMessage(product.title, translations);
            }
            return false;
        }
        return true;
    });
};
